import React from 'react'
import { ConfirmDialog } from 'primereact/confirmdialog'
import { DialogProps } from './Dialog'
import '../messages.scss'

export interface ConfirmDialogProps extends DialogProps {
    message: string
    acceptLabel: string
    rejectLabel: string
    accept: () => void
    reject: () => void
    icon?: string
    acceptIcon?: string
    rejectIcon?: string
    acceptClassName?: string
    rejectClassName?: string
    className?: string
}

export const AlertDialog = (props: ConfirmDialogProps) => {
    const {
        message,
        acceptLabel,
        rejectLabel,
        accept,
        reject,
        icon,
        acceptIcon,
        rejectIcon,
        acceptClassName,
        rejectClassName,
        className,
    } = props
    return (
        <ConfirmDialog
            {...props}
            className={`${'wardrobe-confirm-dialog'} ${
                className ? className : ''
            }`}
            acceptLabel={acceptLabel ? acceptLabel : 'Confirm'}
            rejectLabel={rejectLabel ? rejectLabel : 'Cancel'}
            acceptClassName={`wardrobe-button ${
                acceptClassName ? acceptClassName : ''
            }`}
            rejectClassName={`wardrobe-button ${
                rejectClassName
                    ? rejectClassName
                    : 'p-button-secondary p-button-outlined'
            }`}>
            {props.children ? props.children : <></>}
        </ConfirmDialog>
    )
}
